import { fetchBaseQuery } from '@reduxjs/toolkit/query';

const baseLocalQuery = fetchBaseQuery({
  baseUrl: `/api`,
});

export default baseLocalQuery;
